import { render, staticRenderFns } from "./cmpPreviewListComp.vue?vue&type=template&id=2b2ad10c&scoped=true"
import script from "./cmpPreviewListComp.vue?vue&type=script&lang=js"
export * from "./cmpPreviewListComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2ad10c",
  null
  
)

export default component.exports